import { render } from "./SitemapsTable.vue?vue&type=template&id=0c395c4f&scoped=true"
import script from "./SitemapsTable.vue?vue&type=script&lang=ts"
export * from "./SitemapsTable.vue?vue&type=script&lang=ts"

import "./SitemapsTable.vue?vue&type=style&index=0&id=0c395c4f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0c395c4f"

export default script